import { render, staticRenderFns } from "./serviceCmmodityCreation.vue?vue&type=template&id=2025736b&scoped=true"
import script from "./serviceCmmodityCreation.vue?vue&type=script&lang=js"
export * from "./serviceCmmodityCreation.vue?vue&type=script&lang=js"
import style0 from "./serviceCmmodityCreation.vue?vue&type=style&index=0&id=2025736b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025736b",
  null
  
)

export default component.exports